export interface IColorPickerButtonData {
  key: string
  color: string
}

export interface IPreviousColorPickerButtonData {
  [key: string]: string
}

export enum TypeColorPickerEnum {
  CURRENT = 'current',
  PREVIOUS = 'previous',
}

export type ColorPickerButton = Record<
  TypeColorPickerEnum,
  Record<string, string>
>
